const routes = {
    mainRoute: JSON.parse(localStorage.getItem('storeDeatils'))?.domain?.trim(),
    preSignIn: 'signin',
    signIn: 'store',
    // forgotPassword: 'forgot-password',
    // resetPassword: 'reset-password',
    // notAuthorize: 'not-authorize',
    containers: {
        home: 'home',
        inventory: 'inventory',
        deliveries: 'deliveries',
        payouts: 'payouts',
        transfers: 'transfers',
        orders: 'orders',
        settings: 'settings',
        account: 'account',
        products: 'products',
        'print-queue': 'print-queue',
        'stock-calls': 'stock-calls',
        users: 'users',
        reports: 'reports',
        customers: 'customers',
        'consumer-orders': 'b2b',
        'access-list': 'b2b/access-list',
        buyers: 'b2b/buyers',
        'purchase-order': 'purchase-order',
        buying: 'purchase-order/buying',
    },
    inventory: {
        inventory: {
            name: 'inventory',
            add: 'add-inventory',
            edit: 'edit-inventory',
            view: 'view-inventory',
            'print-queue': 'print-queue',
        },
    },
    consigner: {
        home: 'consigner',
        payouts: 'payouts',
    },
    superAdmin: {
        home: 'super-admin',
    },
};

export default routes;
